<template>
  <div class="container">
    <div v-if="isLoading" class="loading-screen">
      <div class="spinner"></div>
      <p>جاري التحميل...</p>
    </div>

    <h1>قائمة مناظرات سلك التسيير</h1>

    <div class="table-responsive">
      <table class="custom-table">
        <thead>
          <tr>
            <th>رمز المناظرة</th>
            <th>خطة المناظرة</th>
            <th>عدد الخطط</th>
            <th>مركز العمل</th>
            <th>المستوى التعليمي والاختصاص</th>
            <th>التسجيل</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>25/15</td>
            <td>مشغل مصفاة (Opérateur)</td>
            <td>10</td>
            <td>بنزرت</td>
            <td> متحصل على شهادة الباكالوريا (علوم تجريبية، رياضيات، تقنية، إعلامية، رياضة) أو متحصل على مؤهل تقني مهني ( اختصاص إعلامية، كهرباء، آلات دقيقة، ميكانيك، إلكترو ميكانيك،صيانة صناعية، إلكترونيك، إلكتروتكنيك )</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/15')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/16</td>
            <td>Assistante de Direction مساعد مديرية</td>
            <td>3</td>
            <td>بنزرت</td>
            <td>شهادة التقني السامي اختصاص مساعد مديرية أو ما يعادلها.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/16')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/17</td>
            <td>تقني سامي مؤهل</td>
            <td>6</td>
            <td>بنزرت</td>
            <td>الإجازة (التطبيقية أو الأساسية) أو مؤهل تقني سامي في الكيمياء.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/17')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/18</td>
            <td>تقني سامي مؤهل</td>
            <td>2</td>
            <td>بنزرت</td>
            <td>الإجازة (التطبيقية أو الأساسية) أو مؤهل تقني سامي في الهندسة الميكانيكية.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/18')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/19</td>
            <td>تقني سامي مؤهل</td>
            <td>2</td>
            <td>بنزرت</td>
            <td>الإجازة (التطبيقية أو الأساسية) أو مؤهل تقني سامي في الهندسة الكهربائية.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/19')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/20</td>
            <td>تقني سامي مؤهل</td>
            <td>3</td>
            <td>بنزرت</td>
            <td>الإجازة (التطبيقية أو الأساسية) أو مؤهل تقني سامي في التصرف في الموارد البشرية.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/20')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/21</td>
            <td>تقني سامي مؤهل</td>
            <td>1</td>
            <td>بنزرت</td>
            <td>الإجازة (التطبيقية أو الأساسية) أو مؤهل تقني سامي في الإلكترونيك و والكهروتقنية والآلية.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/21')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/22</td>
            <td>تقني سامي مؤهل</td>
            <td>3</td>
            <td>بنزرت</td>
            <td>الإجازة (التطبيقية أو الأساسية) أو مؤهل تقني سامي في إدارة الأعمال: التصرف المحاسبي والمالي.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/22')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
          <tr>
            <td>25/23</td>
            <td>عون تقني للصيانة</td>
            <td>2</td>
            <td>بنزرت</td>
            <td>شهادة مؤهل تقني مهني اختصاصات تقنية.</td>
            <td>
              <router-link to="/formcom" class="register-link" @click.prevent="setExamId('25/23')">
                <i class="fas fa-user-plus"></i> تسجيل
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecruitmentTable2",
  data() {
    return {
      isLoading: true
    };
  },
  mounted() {
    setTimeout(() => {
      const loadingScreen = document.querySelector('.loading-screen');
      if (loadingScreen) {
        loadingScreen.style.transition = 'opacity 0.8s ease';
        loadingScreen.style.opacity = '0';
        setTimeout(() => {
          this.isLoading = false;
        }, 800);
      }
    }, 2000);
  },
  methods: {
    setExamId(id) {
      localStorage.setItem('examId', id);
      console.log('ID saved in localStorage:', id); // باش تشوف القيمة مباشرة
      this.$router.push('/formcom');
    }
  }
};
</script>


<style scoped>
.container {
  direction: rtl;
  padding: 20px;
  font-family: Arial, sans-serif;
  background: #f4f4f4;
  min-height: 100vh;
  direction: rtl;
}
.loading-screen {
    position: fixed;
    inset: 0;
    background: linear-gradient(135deg, var(--primary), var(--primary-light));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 9999;
  }
  
  .spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255,255,255,0.3);
    border-top: 4px solid var(--accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
h1 {
  text-align: center;
  margin-bottom: 20px;
}

.table-responsive {
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ccc;
  padding: 10px;
  vertical-align: top;
  text-align: center;
}

.custom-table th {
  background: #0055a5;
  color: white;
  font-weight: bold;
}

.custom-table tbody tr:nth-child(even) {
  background: rgba(0, 85, 165, 0.05);
}

.custom-table tbody tr:hover {
  background: #e6f0ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,85,165,0.2);
  transition: all 0.3s ease;
}

.register-link {
  display: inline-block;
  background: linear-gradient(45deg, #0055a5, #ffd700);
  color: #fff;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 12px;
  text-decoration: none;
  box-shadow: 0 5px 15px rgba(0, 85, 165, 0.3);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.register-link:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 85, 165, 0.4);
  text-decoration: none;
}
.register-link::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: skewX(-25deg);
  transition: all 0.5s ease;
}

.register-link:hover::after {
  left: 200%;
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-table th,
  .custom-table td {
    padding: 8px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .custom-table th,
  .custom-table td {
    padding: 6px;
    font-size: 0.8rem;
  }
}
</style>
